import './PauseMenu.css';

const PauseMenu = ({ onResume, onMainMenu }) => {
  return (
    <div className="pause-overlay">
      <div className="pause-container">
        <h1 className="pause-title">Paused</h1>
        <p className="pause-subtitle">Take a break</p>
        
        <div className="pause-buttons">
          <button 
            className="pause-button pause-button-primary" 
            onClick={onResume}
            autoFocus
          >
            Resume Game
          </button>
          <button 
            className="pause-button pause-button-secondary" 
            onClick={onMainMenu}
          >
            Main Menu
          </button>
        </div>

        <div className="pause-hint">
          <p>Press <span className="key-hint">ESC</span> to resume</p>
        </div>
      </div>
    </div>
  );
};

export default PauseMenu;

